import type { ReactNode } from 'react'

const ScrollItem = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <div className={`shrink-0 grow-0 ${className ?? ''}`}>{children}</div>
}

export default ScrollItem
